

/**
 * 
 */
class Container {
  constructor () {
    this._container = new Map();
    console.log('构建实例收集器');
  }
  /**
   * 获取实例
   * @param {*} name 
   * @returns 
   */
  get (name) {
    return this._container.get(name);
  }
  has (name) {
    return this._container.has(name);
  }
  /**
   * 注册实例
   * @param {*} name 
   * @param {*} instance 
   */
  add (name, instance) {
    this._container.set(name, instance);
  }
  remove (name) {
    if (this.has(name)) {
      this._container.delete(name);
    }
  }
};
const container = new Container();
export { container, Container };